var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroku4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2500 2500",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2500v2500H0z",
    fill: "#6762a5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.5 1969.9v-787.4s51.2-188.4-630.9 77.1c-1.2 3.4-1.2-728.2-1.2-728.2l222.9-1.4v468.7s624-245.8 624 186.4v784.8zm127-1156.2h-236.4c85.1-104 162.1-282.3 162.1-282.3h244.4c.1 0-41.8 116.2-170.1 282.3zM789.4 1968.6v-448.4l224.2 224.2z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku4);
export default __webpack_public_path__ + "static/media/heroku-4.b7e7f910d905c15ac7d6cca770ba02b0.svg";
export { ForwardRef as ReactComponent };